module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MR-c4a2f73684dd68827ecd9bc9ace7871e.png";